export interface UserDevice {
  userDeviceId: number;
  userId: number;
  os: string;
  browser: string;
  userAgent: string;
  browserVersion: string;
  type: UserDevicesType;
  token: string;
  lastAccess: Date;
  createdAt: Date;
  updatedAt: Date;
  isActive: boolean;
  platform?: UserDevicesPlatform;
}

export enum UserDevicesType {
  DESKTOP = 'DESKTOP',
  MOBILE = 'MOBILE',
}

export enum UserDevicesPlatform {
  ADMIN = 'ADMIN',
  LIVECHAT = 'LIVECHAT'
}

export type SaveUserDeviceRespose = {
  idUserDevice: number;
  idUser: number;
  deviceOs: string;
  type: UserDevicesType;
  userAgent: string;
  token: string;
  lastAccess: number;
  isActive: boolean;
  platform: UserDevicesPlatform;
  createdAt: number;
  updatedAt: number;
};

export type SaveUserDevice = Pick<
  SaveUserDeviceRespose,
  'deviceOs' | 'userAgent' | 'token' | 'type' | 'platform'
> & { isActive?: boolean };
